import Axios from "axios";

export const SelectSousFamille = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/NOME?cat=SF&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "SOUS_FAMILLE_SELECT", payload: response.data });
    });
  };
};
